import { render } from "./DataTableBasic.vue?vue&type=template&id=437912d4"
import script from "./DataTableBasic.vue?vue&type=script&lang=js"
export * from "./DataTableBasic.vue?vue&type=script&lang=js"
script.render = render

export default script